
























































import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { adjust_credits } from '@/config/adjust_credits';

interface Subscription {
  id: number;
  center_id: number;
  remaining_credits: number;
}

@Component({
  name: 'bpc-adjust-credits-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
  },
})
export default class AdjustCreditForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop({ type: Object }) readonly subscription: Subscription;

  // DATA
  public formModel: Partial<Subscription> = {
    remaining_credits: null,
  };

  // LIFECYCLE
  // created(){}
  mounted() {
    this.initFormModel();
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED

  get savePath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('subscription')}/adjust-credits`;
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get fieldsConfig() {
    return adjust_credits;
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }
  // METHODS
  initFormModel() {
    this.formModel.remaining_credits = this.subscription.remaining_credits;
  }

  incrementCredit() {
    this.formModel.remaining_credits++;
  }
  decrementCredit() {
    this.formModel.remaining_credits--;
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  get creditsToAdd() {
    return this.formModel.remaining_credits - this.subscription.remaining_credits;
  }

  // WATCHERS
}
